<template>
  <div class="relationDialog">
    <div class="deviceDetails">
      <div class="contentWrap leftDataComWrap">
        <div class="photoBox">
          <el-image
            :src="list.img"
            style="width: 100%; height: 100%"
            fit="fill"
          >
            <div slot="error" class="image-slot">
              <el-empty description=""></el-empty>
            </div>
          </el-image>
          <div
            class="state"
            :style="{
              background: list.active ? '#27df7c' : '#e7e7e7',
              color: list.active ? '#fff' : '#999',
            }"
          >
            {{ list.active ? "在 线" : "离 线" }}
          </div>
        </div>
        <el-descriptions
          border
          :column="1"
          labelClassName="typeLabelName"
          title="设备数据"
          style="margin-top: 20px"
        >
          <el-descriptions-item
            v-for="(v, i) in loadData"
            :key="i"
            :label="v.display"
          >
            <p style="color: #28cccb; font-weight: bold">
              {{ v.value }} <span>{{ v.unit }}</span>
            </p>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions
          border
          :column="1"
          labelClassName="labelName"
          style="margin-top: 20px"
          size="small"
          title="设备信息"
        >
          <el-descriptions-item label="名称">
            {{ list.name }}
          </el-descriptions-item>
          <el-descriptions-item
            label="运行状态"
            v-if="jumpItem.label == '用能设备'"
          >
            {{ list.state == "1" ? "正常" : list.state == "0" ? "异常" : "" }}
          </el-descriptions-item>
          <el-descriptions-item label="设备类型">
            {{ list.type }}
          </el-descriptions-item>
          <el-descriptions-item label="标签">
            {{ list.label }}
          </el-descriptions-item>
          <el-descriptions-item label="表号">
            {{ list.num }}
          </el-descriptions-item>
          <el-descriptions-item label="编码">
            {{ list.encode }}
          </el-descriptions-item>
          <el-descriptions-item label="所属资产">
            {{ list.upperAssetName }}
          </el-descriptions-item>
          <el-descriptions-item label="所属资产类型">
            {{ list.upperAssetType }}
          </el-descriptions-item>
          <el-descriptions-item label="关联设备">
            {{ list.deviceName }}
          </el-descriptions-item>
          <el-descriptions-item label="安装地点">
            {{ list.location }}
          </el-descriptions-item>
          <el-descriptions-item label="安装时间">
            {{ list.time ? list.time : list.createdTime }}
          </el-descriptions-item>
          <el-descriptions-item label="备注">
            {{ list.remark ?? "" }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <div class="comprehensive">
      <div class="contentWrap commonWrap" style="overflow: hidden">
        <div class="menuBox">
          <TabMenuCom :activeItem="jumpItem" />
        </div>
        <div class="detailedBox">
          <MaintenanceRecord
            v-if="activeName == '维修记录'"
            :activeItem="jumpItem"
          />

          <ChartLine
            v-if="activeName == '参数'"
            :activeItem="jumpItem"
            :activeParamsOption="activeParamsOption"
            :activeIdWithParams="activeIdWithParams"
          />
          <RunningTime
            v-if="
              judgeAuthority('shebei:equipmentmanagement:edit') &&
              activeName == '时间设置'
            "
            :activeItem="jumpItem"
          />
          <WorkRecord v-if="activeName == '工单记录'" :activeItem="jumpItem" />
          <WarningRecord
            v-if="activeName == '报警记录'"
            :activeItem="jumpItem"
          />
          <AlarmConfiguration
            v-if="
              judgeAuthority('shebei:equipmentmanagement:edit') &&
              activeName == '预警设置'
            "
            :activeItem="jumpItem"
          />
          <TimeOff
            v-if="
              judgeAuthority('shebei:equipmentmanagement:edit') &&
              activeName == '定时关闭'
            "
            :activeItem="jumpItem"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import LeftDataCom from "@/components/shebeiguanli/popup/LeftDataCom.vue";
import TabMenuCom from "@/components/shebeiguanli/equipment/TabMenuCom";
import MaintenanceRecord from "@/components/shebeiguanli/MaintenanceRecord.vue";

import AlarmConfiguration from "@/components/shebeiguanli/AlarmConfiguration.vue";
import ChartLine from "@/components/shebeiguanli/equipment/ChartLine.vue";
import RunningTime from "@/components/shebeiguanli/RunningTime.vue";
import WarningRecord from "@/components/shebeiguanli/equipment/WarningRecord.vue";
import WorkRecord from "@/components/shebeiguanli/equipment/WorkRecord.vue";
import TimeOff from "@/components/shebeiguanli/equipment/TimeOff.vue";
import {
  getProjectVal,
  judgeAuthority,
  handleNumDecimal,
} from "@/assets/js/utils";
export default {
  props: ["jumpItem"],
  components: {
    LeftDataCom,
    TabMenuCom,
    AlarmConfiguration,
    MaintenanceRecord,
    ChartLine,
    RunningTime,
    WorkRecord,
    WarningRecord,
    TabMenuCom,
    TimeOff,
  },
  data() {
    return {
      list: {},
      loadData: [],
      tabSelect: "",
      activeName: "",
      activeParamsOption: [],
      activeIdWithParams: "",
    };
  },
  watch: {
    jumpItem: {
      handler(newvalue, oldvalue) {
        this.getDetailsList();
        this.getLoadData();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    judgeAuthority,
    async getDetailsList() {
      if (this.jumpItem) {
        let res = await api.getSDetailsList({}, this.jumpItem.deviceId);
        if (res && res.status == 200) {
          this.list = res.data;
          this.list.time = res.data.createdTime
            ? dateFtt("yyyy-MM-dd hh:mm:ss", new Date(res.data.createdTime))
            : res.data.time;
          if (this.list.image) {
            let httpUrl = window.jujiParams.baseURL;
            this.list.img = `${httpUrl}/${this.list.image}?tenant_id=${
              JSON.parse(window.sessionStorage.getItem("userInfo")).tenantId
            }`;
          }
          this.list.deviceName = this.list.relatedDevice
            .map((obj) => {
              return obj.name;
            })
            .join(",");
        }
      } else {
        this.list = {};
      }
    },
    async getLoadData() {
      this.loadData = [];
      let res = await api.getSDeviceLoadData({
        deviceId: this.jumpItem.deviceId,
        type: this.jumpItem.deviceType,
        projectId: getProjectVal("Id"),
      });
      // console.log("负载数据", res);
      if (res && res.status == 200) {
        if (res.data.data.length) {
          res.data.data.forEach((el) => {
            if (!this.loadData.some((e) => e.display == el.display)) {
              this.loadData.push(el);
            }
          });
          if (this.jumpItem.label == "用能设备") {
            this.loadData.forEach((v, i) => {
              if (i >= 3 && i < 6) {
                v.value =
                  i == 3
                    ? handleNumDecimal(v.value / 60)
                    : handleNumDecimal(v.value / 60 / 24);
                v.unit = i == 3 ? "H" : "天";
              }
            });
          }
          this.loadData.map((v) => {
            if (v.display.includes("开关状态")) {
              v.value = v.value == 0 ? "关闭" : "开启";
            } else {
              v.value = handleNumDecimal(v.value);
            }
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.relationDialog {
  height: 100%;
  width: 100%;
  background: #f7f7f7;
  @include setFlexBetween;
  .contentWrap {
    width: 95%;
    height: calc(100% - 40px);
    margin: 20px auto;
    overflow: auto;
  }
  .leftDataComWrap {
    ::v-deep .el-descriptions {
      .labelName {
        width: 30%;
      }
      .typeLabelName {
        width: 34%;
      }
      .el-descriptions__title {
        font-size: 15px;
        font-weight: 600;
      }
    }
    .photoBox {
      width: 70%;
      height: 220px;
      margin: 0 auto;
      background: #f7f7f7;
      border: 1px solid #cccccc;
      border-radius: 20px;
      overflow: hidden;
      position: relative;
      .state {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 40px;
        width: 100%;
        opacity: 0.8;
        background: #27df7c;
        color: #fff;
        @include setFlexCenter;
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
  .deviceDetails {
    width: 28%;
    height: 100%;
    background: #fff;
  }
  .comprehensive {
    width: 72%;
    height: 100%;
    .menuBox {
      width: 98%;
      height: 7%;
      margin: 10px auto 0;
    }
    .detailedBox {
      width: 100%;
      height: calc(93% - 20px);
      margin: 0 auto;
    }
  }
}
</style>
